import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';

import type { StackProps } from '@mui/material';

export interface BadgeProps extends StackProps {
  color: 'primary' | 'secondary' | 'black';
  label: string;
}

const EliceBadge = ({ label, color, ...rest }: BadgeProps) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        borderRadius: '0.6875rem',
        padding: '0.375rem 0.875rem',
        color: '#fff',
        width: 'fit-content',
        backgroundColor:
          color === 'primary'
            ? theme.palette.primary.main
            : color === 'secondary'
              ? theme.palette.secondary.main
              : theme.palette.primary.dark,
      }}
      {...rest}
    >
      <Typography
        variant="h3"
        style={{
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
};
export default EliceBadge;
